/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import { combineReducers } from 'redux';
import * as ActionTypes from './actionTypes';

/**
 * Updates the Life Event Categories of the 'UALifeEventCategories' store object.
 *
 * @param {*} [state={}]
 * @param {*} action
 * @returns
 */
function selectLifeEventCategoriesReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, ActionTypes.GET_LIFE_EVENT_CATEGORIES);
}

/**
 * Updates the flag that is set while we are fetching the Life Event Categories.
 *
 * @param {*} [state={}]
 * @param {*} action
 * @returns
 */
function isFetchingLifeEventCategoriesReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateFetchingReducer(state, action, ActionTypes.GET_LIFE_EVENT_CATEGORIES);
}

/**
 * Updates the error object for the Life Event Categories GET request.
 *
 * @param {*} [state={}]
 * @param {*} action
 * @returns
 */
function fetchLifeEventCategoriesErrorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateErrorReducer(state, action, ActionTypes.GET_LIFE_EVENT_CATEGORIES);
}

/**
 * Updates the currently-selected Life Event Context.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */

/**
 * Updates the flag for whether all life events are visible or not.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
function hasAllLifeEventsVisibleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return ReduxUtils.generateReducer(state, action, {
    successAction: ActionTypes.HAS_ALL_LIFE_EVENTS_VISIBLE
  });
}
var reducers = combineReducers({
  selectLifeEventCategories: selectLifeEventCategoriesReducer,
  isFetchingLifeEventCategories: isFetchingLifeEventCategoriesReducers,
  fetchLifeEventCategoriesError: fetchLifeEventCategoriesErrorReducer,
  hasAllLifeEventsVisible: hasAllLifeEventsVisibleReducer
});
export default {
  reducers: reducers
};